import axios from './base'

// 首页报表 API（后端 app/Controller/ReportController，路由 /report）
// 报表与概览（api/home.js）分开成套：概览是数字卡，这里是图表数据源

// 报表总览：一次返回 5 组图表数据
//   trend              近 N 日新增趋势 { days, dates[], user_counts[], appointment_counts[] }
//   appointment_status 预约状态分布 [{ status, label, value }]
//   user_region        用户地区分布 [{ province, value }]（按省份降序取前 8）
//   verify             核销结果 { total, success, fail: [{ reason, value }] }
//   post_type          社区内容构成 [{ type, label, value }]
// params.days 可指定趋势天数（默认 30，后端上限 90）
export function getReportOverview(params = {}) {
  return axios.request({
    url: '/report/overview',
    method: 'get',
    params,
  })
}
